import { TransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/TransactionViewDrawer";
import { useOverlays } from "../../../contexts/OverlayContext";
import { SimilarTransactionsUpdateActionsBarLegacy } from "./SimilarTransactionsUpdateActionsBarLegacy";
import styles from "./SimilarTransactionsUpdateDrawerLegacy.module.scss";

export const SimilarTransactionsUpdateDrawerLegacy: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("similarTransactionsUpdate");

    if (!overlayInfo || !overlayInfo.data) {
        return null;
    }

    return (
        <TransactionViewDrawer
            view={overlayInfo.data.view}
            open={!overlayIsClosing}
            onClose={() => {
                closeOverlay();
            }}
            parentFilters={overlayInfo.data.filters}
            headerAddon={() => (
                <div className={styles.header}>Review similar transactions</div>
            )}
            selectAllOnOpen
            actionComponent={() => (
                <SimilarTransactionsUpdateActionsBarLegacy
                    valueToAssign={overlayInfo.data!.valueToAssign}
                    onUndo={() => {
                        closeOverlay();
                    }}
                    displayedChangedEntityName={
                        overlayInfo.data!.displayedChangedEntityName
                    }
                />
            )}
        />
    );
};
